export const SEARCH_ENDPOINT = 'gateway/api/xpsearch-aggregator';
